import axios, { type AxiosResponse } from "axios";
import { SystemViewUserItemSchema } from "@/schemas/index";
import type { SystemViewUserItemType } from "@/schemas/index";
import env from "@/app/config/env";

export interface ServiceSystemViewApi {
  fetchSystemUserList: (query: string) => Promise<SystemViewUserItemType[]>;
}

export const serviceSystemViewApi: ServiceSystemViewApi = {
  fetchSystemUserList: (query) => {
    return axios
      .get(`${env.services.portal}/system/users?search=${query}`)
      .then((response: AxiosResponse<unknown[]>) => {
        return (
          response?.data?.map((item: unknown) =>
            SystemViewUserItemSchema.parse(item),
          ) || []
        );
      });
  },
};
